// WARNING: DO NOT EDIT. This file is automatically generated.

const awsConfig = {
    "region": "us-east-1",
    "stage": "prod",
    "accountName": "peacock-integration",
    "api_url": "https://m9rd7vba7d.execute-api.us-east-1.amazonaws.com/prod/graphql",
    "notifications_api_url": "https://m9rd7vba7d.execute-api.us-east-1.amazonaws.com/prod/notifications",
    "run_daily_test_url": "https://1bedzbg3b2.execute-api.us-east-1.amazonaws.com/prod/run-daily-test",
    "sport_highlights_url": "https://nbyryio3xfdyjkoa5xdf2d37nu.appsync-api.us-east-1.amazonaws.com/graphql",
    "appconfig_url": "https://m9rd7vba7d.execute-api.us-east-1.amazonaws.com/prod/getConfig",
    "direct_appconfig_url": "https://te9x6oxy91.execute-api.us-east-1.amazonaws.com/prod",
		"endpoint_url" : "https://m9rd7vba7d.execute-api.us-east-1.amazonaws.com/prod",
    "mgmt_ui_appconfig_dropdown_profile": "mgmt-ui-dropdown-options",
    "mgmt_ui_appconfig_configs_profile": "mgmt-ui-configs",
    "daily-test-game-configs": "daily-testing-configs",
    "leagues": "leagues",
    "aws_project_region": "us-east-1",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_zkJM5hrWD",
    "aws_user_pools_web_client_id": "300g6ap606o5p9uc1tp6kj0s43",
    "oauth": {
        "domain": "spex-mgmt-ui-hosting-peacock-integration-prod.auth.us-east-1.amazoncognito.com",
        "scope": [
          "phone",
          "email",
          "profile",
          "openid",
          "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://mgmt.peacock-integration.aidisco.sky.com",
        "redirectSignOut": "https://mgmt.peacock-integration.aidisco.sky.com",
        "responseType": "code"
    },
    "defaultChannelName": "ExternalSLE",
    "playfactoryLicenseAcquisitionEndpointUrl": "https://whd9jue73e.execute-api.us-east-1.amazonaws.com/prod",
    "arcusLicenseAcquisitionEndpointUrl": "https://91hstwbcy0.execute-api.us-east-1.amazonaws.com/prod",
    "viperProxyUrl": ""
};

export default awsConfig;

